import { Component, ElementRef, ViewChild } from '@angular/core';
import { BookingService, NavigationService, AppPageBase, LayoutService, BookingModel } from 'app-components';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { PageBase, UIService, LocationInfo } from 't4core';


@Component({
  selector: 'location-list-component',
  templateUrl: './location-list.component.html',
/*  styleUrls: ['./location-list.component.css'],*/
  standalone: false
})
export class LocationList extends PageBase {

  @ViewChild('search')
  private searchElement: ElementRef;
  public locations: LocationInfo[];
  public availableLocations: LocationInfo[];
  public userLat: number;
  public userLong: number;
  public selectedLocation: LocationInfo;
  public filteredLocations: LocationInfo[];
  public searchText: string = '';
  public bookingState: BookingModel;

  constructor(
    private navigator: NavigationService,
    el: ElementRef,
    private appService: AppIntegrationService,
    public layout: LayoutService,
    public appSettings: AppSettingsService,
    private bookingSvc: BookingService,
    private BookingDataSerivce: BookingService)
  {
    super(el, "LocationList");
  }

  async ngOnInit() {

    this.bookingState = this.BookingDataSerivce.getBookingState();
    this.locations = await this.BookingDataSerivce.getLocations();

    this.availableLocations = this.locations;
    if (this.bookingState.objectCategory != null) {
      this.availableLocations = this.locations.filter(item => item.HasFamilies?.includes(this.bookingState.objectCategory.Id));
    }
    
    if (this.appSettings.appType == 'web') {
      this.filteredLocations = this.locations.slice(0, 15);
    }
    else {
      this.filteredLocations = this.locations;
    }
  }

  filterLocations(value: string) {
    this.searchText = value.toLowerCase();

    this.filteredLocations = this.locations.filter(loc => {
      const name = (loc?.Name ?? '').toLowerCase();
      const city = (loc?.City ?? '').toLowerCase();
      return name.includes(this.searchText) || city.includes(this.searchText);
    });


    if (this.appSettings.appType == 'web') {
      this.filteredLocations = this.filteredLocations.sort((a, b) => a.Distance - b.Distance).slice(0, 15);
    }
    else {
      this.filteredLocations = this.filteredLocations.sort((a, b) => a.Distance - b.Distance);
    }
  }

  public showMap() {
    this.navigator.executeCommand("Map");
  }

  public clearSearch() {
    this.searchText = '';
    this.filteredLocations = this.locations;
  }

  public async selectLocation(loc: LocationInfo) {
    if (loc) {
      await this.BookingDataSerivce.setPickupLocation(loc);

      this.navigator.executeCommand("NewBooking");
    }
  }
}
